import { renderToStaticMarkup } from 'react-dom/server';
import { MapPopup } from './MapPopup';
import type { MapPopupProps } from './MapPopup.types';

export function renderMapPopupToString(props: MapPopupProps): string {
  return renderToStaticMarkup(<MapPopup {...props} />);
}

export function createMapPopupElement(props: MapPopupProps): HTMLElement {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = renderMapPopupToString(props);

  const element = wrapper.firstElementChild;
  if (!element) {
    throw new Error('MapPopup render did not produce a root element');
  }

  return element as HTMLElement;
}
